var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSickLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 65,
    viewBox: "0 0 67 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.3398 55.1953C57.0518 55.1953 57.6289 54.6182 57.6289 53.9063C57.6289 53.1943 57.0518 52.6172 56.3398 52.6172C55.6279 52.6172 55.0508 53.1943 55.0508 53.9063C55.0508 54.6182 55.6279 55.1953 56.3398 55.1953Z",
    fill: "url(#paint0_linear_1919_6979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.0604 28.7427C25.5481 28.7427 27.572 26.7186 27.572 24.2307C27.572 21.7428 25.5481 19.7188 23.0604 19.7188C20.5728 19.7188 18.5488 21.7428 18.5488 24.2307C18.5488 26.7186 20.5728 28.7427 23.0604 28.7427ZM23.0604 22.2971C24.1266 22.2971 24.994 23.1645 24.994 24.2309C24.994 25.297 24.1266 26.1646 23.0604 26.1646C21.9942 26.1646 21.1268 25.2972 21.1268 24.2309C21.1268 23.1645 21.9942 22.2971 23.0604 22.2971Z",
    fill: "url(#paint1_linear_1919_6979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.9766 24.2307C40.9766 26.7186 43.0005 28.7427 45.4882 28.7427C47.9758 28.7427 49.9997 26.7186 49.9997 24.2307C49.9997 21.7428 47.9758 19.7188 45.4882 19.7188C43.0005 19.7189 40.9766 21.743 40.9766 24.2307ZM47.4216 24.2307C47.4216 25.2969 46.5543 26.1645 45.488 26.1645C44.4217 26.1645 43.5544 25.297 43.5544 24.2307C43.5544 23.1645 44.4217 22.297 45.488 22.297C46.5543 22.297 47.4216 23.1645 47.4216 24.2307Z",
    fill: "url(#paint2_linear_1919_6979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.275 12.8863C25.4191 12.1891 24.9709 11.507 24.2737 11.3628C23.5764 11.2189 22.8945 11.6671 22.7502 12.3642C22.5791 13.1919 21.9521 13.9942 20.9847 14.623C19.6332 15.5016 17.8124 15.8934 16.4538 15.5981C15.758 15.4466 15.0716 15.8881 14.9204 16.5838C14.769 17.2795 15.2104 17.9662 15.906 18.1174C16.3958 18.2239 16.91 18.2758 17.4363 18.2758C19.1119 18.2758 20.9057 17.7495 22.3897 16.7848C23.9386 15.7779 24.9633 14.3934 25.275 12.8863Z",
    fill: "url(#paint3_linear_1919_6979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M52.0962 15.598C50.7382 15.8933 48.9171 15.5016 47.5654 14.6231C46.5978 13.9941 45.9708 13.192 45.7996 12.3641C45.6554 11.6669 44.9722 11.219 44.2762 11.3628C43.5791 11.507 43.1309 12.1891 43.275 12.8863C43.5867 14.3935 44.6115 15.7779 46.1604 16.7848C47.6445 17.7496 49.438 18.2758 51.1138 18.2758C51.6399 18.2758 52.1545 18.2239 52.6442 18.1173C53.3397 17.9661 53.7811 17.2794 53.6298 16.5837C53.4784 15.8879 52.7915 15.4464 52.0962 15.598Z",
    fill: "url(#paint4_linear_1919_6979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.94727 32.8672C7.6592 32.8672 8.23633 32.2901 8.23633 31.5781C8.23633 30.8662 7.6592 30.2891 6.94727 30.2891C6.23534 30.2891 5.6582 30.8662 5.6582 31.5781C5.6582 32.2901 6.23534 32.8672 6.94727 32.8672Z",
    fill: "url(#paint5_linear_1919_6979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56.588 8.96827C50.6314 3.25243 42.5255 0 34.2745 0C25.7445 0 17.3799 3.48047 11.3745 9.54512C6.6875 14.2782 3.58562 20.4416 2.49121 26.9769C2.05138 27.3976 1.66363 27.8868 1.34742 28.4421C0.495483 29.9382 0.276987 31.6765 0.732413 33.337C1.02039 34.387 1.55677 35.326 2.29012 36.0901C3.14953 43.086 6.30864 49.7396 11.2675 54.7952C17.2823 60.9275 25.6883 64.4531 34.2743 64.4531C37.6193 64.4531 40.914 63.9427 44.0721 62.9358C47.1271 61.9612 50.0159 60.5367 52.6557 58.6997C52.938 58.5037 53.1275 58.2085 53.1881 57.8695C53.2488 57.5305 53.1741 57.1876 52.9767 56.9053C52.7369 56.5585 52.3399 56.3523 51.9184 56.3523C51.6541 56.3523 51.4001 56.4322 51.1836 56.583C46.2054 60.0443 40.3597 61.8749 34.2742 61.8749C26.3569 61.8749 18.9115 58.79 13.3095 53.1901C9.05447 48.9327 6.25476 43.6087 5.15506 37.8228C5.99527 38.066 6.87944 38.137 7.7551 38.0261L21.3541 45.7715C20.328 46.9777 19.5 48.3259 18.9024 49.7839C18.6323 50.4427 18.9474 51.1956 19.6061 51.4657C19.7662 51.5313 19.9317 51.5624 20.0946 51.5624C20.6022 51.5624 21.0834 51.2606 21.2878 50.762C23.3043 45.8431 28.5232 42.5382 34.2745 42.5382C40.0257 42.5382 45.2447 45.8431 47.261 50.762C47.5313 51.4207 48.2836 51.7361 48.9427 51.4657C49.6014 51.1956 49.9166 50.4427 49.6465 49.7839C48.4707 46.9156 46.4097 44.4666 43.6864 42.7017C40.9187 40.908 37.6642 39.9599 34.2746 39.9599C33.5764 39.9599 32.8841 40.0008 32.2006 40.081L12.8585 29.0644C12.3054 27.7888 11.3535 26.7237 10.1375 26.0311C8.65048 25.184 6.96568 24.9975 5.42138 25.3747C6.66932 20.0739 9.36346 15.2081 13.3097 11.2598C18.9118 5.65989 26.3572 2.57503 34.2743 2.57503C42.1915 2.57503 49.6369 5.65989 55.2377 11.2598C60.8372 16.8611 63.9206 24.3072 63.9219 32.2249C63.9219 38.1213 62.1945 43.8167 58.9295 48.6973C58.7375 48.9835 58.6692 49.3264 58.7361 49.6641C58.8033 50.0018 58.9978 50.2932 59.284 50.4852C59.4967 50.6283 59.7442 50.7031 59.9994 50.7031C60.4314 50.7031 60.8323 50.4891 61.0719 50.1307C64.6231 44.8274 66.5 38.6345 66.5 32.225C66.5 23.5187 62.8723 14.9984 56.588 8.96827ZM8.86176 28.2715C9.67992 28.7375 10.2988 29.4851 10.6043 30.3765C10.706 30.6735 10.9128 30.9232 11.1857 31.0787L12.2561 31.6884L11.6182 32.8086C11.2659 33.4272 11.4816 34.2144 12.1003 34.5667C12.3016 34.6815 12.5208 34.736 12.7369 34.736C13.185 34.736 13.6206 34.5019 13.8582 34.0846L14.4961 32.9644L16.7364 34.2403L16.0984 35.3605C15.7461 35.9792 15.962 36.7664 16.5807 37.1187C16.782 37.2334 17.0012 37.2879 17.2173 37.2879C17.6654 37.2879 18.101 37.0538 18.3386 36.6366L18.9765 35.5164L21.2168 36.7923L20.5788 37.9125C20.2265 38.5311 20.4424 39.3183 21.0611 39.6706C21.2624 39.7854 21.4816 39.8399 21.6977 39.8399C22.1459 39.8399 22.5814 39.6058 22.819 39.1885L23.4569 38.0683L28.4804 40.9295C26.5617 41.5957 24.797 42.5926 23.2548 43.8873L8.63411 35.5596C8.43843 35.4481 8.21852 35.3906 7.99615 35.3906C7.9085 35.3906 7.82045 35.3995 7.73357 35.4175C6.81099 35.6095 5.85231 35.4585 5.03414 34.9926C4.13657 34.4814 3.49178 33.6512 3.21863 32.6549C2.94535 31.6587 3.07644 30.6158 3.58769 29.7181C4.64291 27.8653 7.00886 27.2162 8.86176 28.2715Z",
    fill: "url(#paint6_linear_1919_6979)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1919_6979",
    x1: 55.0508,
    y1: 52.6172,
    x2: 57.7505,
    y2: 52.7516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1919_6979",
    x1: 18.5488,
    y1: 19.7188,
    x2: 27.9977,
    y2: 20.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1919_6979",
    x1: 40.9766,
    y1: 19.7188,
    x2: 50.4255,
    y2: 20.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1919_6979",
    x1: 14.8906,
    y1: 11.3359,
    x2: 25.7596,
    y2: 12.1476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1919_6979",
    x1: 43.248,
    y1: 11.3359,
    x2: 54.1171,
    y2: 12.1476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1919_6979",
    x1: 5.6582,
    y1: 30.2891,
    x2: 8.35797,
    y2: 30.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1919_6979",
    x1: 0.5,
    y1: 0,
    x2: 69.6057,
    y2: 3.52243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSickLeave);
export default __webpack_public_path__ + "static/media/icon-sick-leave.e04516b1c5e883eb6e1f5f53895a9641.svg";
export { ForwardRef as ReactComponent };